import { CRM_CHAT_FORCE_INTENT_SUGGESTIONS_KEY } from "../constants/chatConstants";

function isIntentSuggestionsMetaDisabled(): boolean {
  if (typeof document === "undefined") return false;
  const meta = document.querySelector('meta[name="chat.intentSuggestions"]');
  return meta?.getAttribute("content") === "false";
}

/**
 * Intent-based prompt suggestions panel (story 3.51).
 * Default on; disable via meta tag or hide panel when hook returns false.
 */
export function useChatIntentSuggestionsFlag(): boolean {
  let qaOverride = false;
  try {
    qaOverride =
      typeof window !== "undefined" &&
      window.sessionStorage.getItem(CRM_CHAT_FORCE_INTENT_SUGGESTIONS_KEY) === "1";
  } catch {
    qaOverride = false;
  }

  if (qaOverride) return true;
  return !isIntentSuggestionsMetaDisabled();
}
